import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    'summaryQuickToggleBillingMethodChoiceOne', // container for toggling the prices to monthly.
    'billingMethodCardChoice', // Radio button for toggling the billing method to card.
    'billingMethodInvoiceChoice', // Radio button for toggling the billing mehtod to invoice.
    ]

    // for readabillity
    canPayMonthly() {
        if (document.getElementById('hidden-field-can-pay-monthly').dataset.canPayMonthly == "true") {
          return true
        }

        return false;
      }

    updateBillingMonthsChoice(e) {
        if (!this.canPayMonthly()) {
            return;
        }

        if (e.target == this.billingMethodInvoiceChoiceTarget) {
            this.summaryQuickToggleBillingMethodChoiceOneTarget.setAttribute('aria-disabled', 'true')
            this.summaryQuickToggleBillingMethodChoiceOneTarget.classList.add("pointer-events-none")
            this.summaryQuickToggleBillingMethodChoiceOneTarget.classList.add("text-gray-300")
        }
        else {
            this.summaryQuickToggleBillingMethodChoiceOneTarget.setAttribute('aria-disabled', 'false')
            this.summaryQuickToggleBillingMethodChoiceOneTarget.classList.remove("pointer-events-none")
            this.summaryQuickToggleBillingMethodChoiceOneTarget.classList.remove("text-gray-300")
        }
    }
}
